import React from 'react';
import { Breadcrumb, Typography, Space } from 'antd';
import { HomeOutlined, FileTextOutlined } from '@ant-design/icons';
import SalesList from '../components/Sales/SalesList';
import SalesSummary from '../components/Sales/SalesSummary';

const { Title } = Typography;

const SalesPage = () => {
    return (
        <div>
            <Breadcrumb
                style={{ marginBottom: '16px' }}
                items={[
                    {
                        href: '/',
                        title: <HomeOutlined />,
                    },
                    {
                        title: (
                            <Space>
                                <FileTextOutlined />
                                <span>Sales Invoices</span>
                            </Space>
                        ),
                    },
                ]}
            />

            <div style={{ marginBottom: '24px' }}>
                <Title level={2}>Sales Invoices</Title>
            </div>

            <SalesSummary />
            <SalesList />
        </div>
    );
};

export default SalesPage;
